export default __webpack_public_path__ + "static/media/our-mission.8ae33abf.png";